import { render, staticRenderFns } from "./face_detection12306.vue?vue&type=template&id=9c2c6c16"
import script from "./face_detection12306.vue?vue&type=script&lang=js"
export * from "./face_detection12306.vue?vue&type=script&lang=js"
import style0 from "./face_detection12306.vue?vue&type=style&index=0&id=9c2c6c16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports